module.exports = __webpack_public_path__ + "static/img/45.73a882d5.png";